import React from 'react';
import { Row, Col, Pager } from 'react-bootstrap';
import { Stage, Layer, Rect, Group, Text } from 'react-konva';
import { inject, observer } from 'mobx-react';
import Block from './Block';
import { injectIntl } from 'react-intl';
import { BLOCK_NAME_BY_KEY, STEPS_BY_SECTION } from './constants';
import { NETWORK_LAYERS } from '../igmvp_components/models/constants';
import { sectionNameByValue } from './functions';
import { NEXT_STEP_UNBUNDLED_BMC, PREV_STEP_UNBUNDLED_BMC } from './constants';
import ZonesResponsibilities from './ZonesResponsibilities';

const blockNameByKey = BLOCK_NAME_BY_KEY;

const bmcBlocksMap = [6, 3, 5, 4, 8, 2, 1, 0, 7];

//const mapBlockNameToKey = (name) => Object.values(BLOCK_NAME_BY_KEY).map( e => e.name).indexOf(name);

@injectIntl
@inject('rootStore')
@observer
export default class BmcKonva extends React.Component {
  constructor(props) {
    super(props);
    this.props.rootStore.currentBlockStep = bmcBlocksMap[props.initialStep];
    this.state = {
      init: props.initialStep || 0,
      sizings: {
        genWidth: 600,
        genHeight: 336,
        canvasWidth: 500,
        canvasHeight: 380
      }
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleKeyPress(e) {
    if (e.keyCode === 37) {
      this.handleButton(false);
    } else if (e.keyCode === 39) {
      this.handleButton(true);
    }
  }

  updateSizing = () => {
    let [genWidth, genHeight, canvasWidth, canvasHeight] = [600, 336, 500, 380];
    let isSidebarOpen = localStorage.getItem('openSidebar') === 'open';
    let multiplier = 1;

    if (window.innerWidth <= 430) multiplier = 0.466; // [280, 156, 232, 180];
    if (isSidebarOpen && window.innerWidth >= 770 && window.innerWidth <= 840)
      multiplier = 0.68;
    else if (
      window.innerWidth < 680 ||
      (window.innerWidth > 990 && window.innerWidth < 1200)
    )
      multiplier = 0.7; // [420, 235, 350, 266];

    if (genWidth !== this.state.sizings.genHeight)
      this.setState({
        sizings: {
          genWidth: genWidth * multiplier,
          genHeight: genHeight * multiplier,
          canvasWidth: canvasWidth * multiplier,
          canvasHeight: canvasHeight * multiplier
        }
      });
  };

  componentDidMount() {
    this.updateSizing();

    document.addEventListener('keydown', this.handleKeyPress);
    window.addEventListener('resize', this.updateSizing);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
    window.removeEventListener('resize', this.updateSizing);
  }

  baseURL() {
    const { history } = this.props;

    let baseUrl = history.location.pathname.substr(
      0,
      history.location.pathname.lastIndexOf('/')
    );
    return baseUrl.substr(0, baseUrl.lastIndexOf('/'));
  }

  handleClick = val => {
    if (this.allowStepChange(val)) {
      const step = blockNameByKey[val].name;
      this.props.rootStore.currentBlockStep = val;
      this.setState({ init: bmcBlocksMap.indexOf(val) });
      this.props.history.push(`${this.baseURL()}/step_mode/${step}`);
    } else {
      this.props.rootStore.generateAlert({
        type: 'warning',
        headline: 'step_by_step_different_section_warning_headline',
        message: 'step_by_step_different_section_warning_message'
      });
    }
  };

  isUnbundled = () => {
    return (
      this.props.rootStore.igMvpRootStore &&
      this.props.rootStore.igMvpRootStore.currentLayer != NETWORK_LAYERS.PRODUCT
    );
  };

  currentSection = () => {
    return sectionNameByValue(this.props.rootStore.currentBlockStep);
  };

  allowStepChange = stepNumber => {
    // When working in BMC sections (unbundled BMC)
    // forbid going to blocks in a different section
    if (stepNumber > 8 || stepNumber < 0) {
      return false;
    }
    if (this.isUnbundled()) {
      return sectionNameByValue(stepNumber) === this.currentSection();
    }
    return true;
  };

  handleButton(bool) {
    const nextStep = this.calcNextStep();
    const prevStep = this.calcPrevStep();
    if (bool && this.allowStepChange(nextStep)) {
      this.handleClick(nextStep);
    } else if (!bool && this.allowStepChange(prevStep)) {
      this.handleClick(prevStep);
    }
  }

  calcNextStep() {
    if (!this.isUnbundled()) {
      return this.state.init < 8
        ? bmcBlocksMap[this.state.init + 1]
        : bmcBlocksMap[0];
    }
    const currentStep = bmcBlocksMap[this.state.init];
    return NEXT_STEP_UNBUNDLED_BMC[currentStep];
  }

  calcPrevStep() {
    if (!this.isUnbundled()) {
      return this.state.init > 0
        ? bmcBlocksMap[this.state.init - 1]
        : bmcBlocksMap[8];
    }
    const currentStep = bmcBlocksMap[this.state.init];
    return PREV_STEP_UNBUNDLED_BMC[currentStep];
  }

  render() {
    let { title } = this.props;
    let { description } = this.props;

    const {
      sizings: { genHeight, genWidth, canvasHeight, canvasWidth }
    } = this.state;

    return (
      <div onKeyPress={this.handleKeyPress}>
        <Row>
          <Col xs={12} md={7}>
            <ZonesResponsibilities />

            <h2 className={'step-header'}>{title}</h2>
            <h4 className={'step-description'}>{description}</h4>
          </Col>
        </Row>
        <Row style={{ paddingTop: 20 }}>
          <Col className={'step-by-step-col'} xs={12} md={7}>
            <div className={'step-by-step-canvas hidden-xs'}>
              <Stage
                key={`${genHeight}-${genWidth}-${canvasHeight}-${canvasWidth}`}
                width={canvasWidth}
                height={canvasHeight}
              >
                <Layer>
                  <BmcCanvasDrawing
                    currentBlock={this.props.rootStore.currentBlockStep}
                    onClick={this.handleClick}
                    genHeight={genHeight * 0.8}
                    genWidth={genWidth * 0.8}
                    isUnbundled={this.isUnbundled()}
                    currentSection={this.currentSection()}
                  />
                </Layer>
              </Stage>
            </div>
            <div id="step-by-step-pager">
              <Pager>
                <Pager.Item onClick={() => this.handleButton(false)}>
                  {' '}
                  &larr; Previous
                </Pager.Item>
                <Pager.Item onClick={() => this.handleButton(true)}>
                  Next &rarr;
                </Pager.Item>
              </Pager>
            </div>
          </Col>

          <TriangleColor
            color={blockNameByKey[this.props.rootStore.currentBlockStep].color}
          />

          <Col xs={12} md={5} style={{ marginTop: -75 }}>
            <div className={'step-by-step-block'}>
              {this.renderCurrentBlock()}
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderCurrentBlock() {
    const blockName =
      blockNameByKey[this.props.rootStore.currentBlockStep].name;
    const blockStore = this.props.rootStore.getBlockStoreByName(blockName);

    return <Block blockStore={blockStore} />;
  }
}

const TriangleColor = props => (
  <Col
    className={'after-step-by-step-col'}
    style={{
      [window.screen.width > 640
        ? 'borderRight'
        : 'borderTop']: `40px solid ${props.color}`
    }}
  />
);

var BmcCanvasDrawing = props => {
  var rectangles = [];
  const { genHeight } = props;
  const { genWidth } = props;
  const { currentBlock } = props;
  const TEXT_SIZE = 30,
    FIX_POS = 10;
  var j = 0;

  console.group();
  console.log('GenHeigth: ', genHeight);
  console.log('GenWidth: ', genWidth);
  console.groupEnd();

  function handleTextColor(val) {
    if (val === currentBlock) {
      return 'white';
    } else {
      if (!props.isUnbundled) {
        return '#333';
      }
      if (sectionNameByValue(val) === props.currentSection) {
        return val === currentBlock ? 'white' : '#333';
      }
      return '#bbb';
    }
  }

  function handleColor(val) {
    if (props.isUnbundled) {
      if (sectionNameByValue(val) === props.currentSection) {
        return val === currentBlock ? blockNameByKey[val].color : 'white';
      }
      return '#f5f5f5';
    }
    return val === currentBlock ? blockNameByKey[val].color : 'white';
  }

  for (var i = 0; i < 5; i++) {
    let rect;
    let rectA;
    let rectB;

    if (i % 2 === 0) {
      const p = j++;

      rect = (
        <Group key={p}>
          <Rect
            x={(i * genWidth) / 5}
            y={0}
            width={genWidth / 5}
            height={genHeight * 0.67}
            fill={handleColor(p)}
            fillImagePattern
            stroke="#333"
            onClick={() => props.onClick(p)}
            shadowForStrokeEnabled
          />
          <Text
            x={(i * genWidth) / 5 + genWidth / 10 - FIX_POS}
            y={(genHeight * 0.67) / 2 - FIX_POS}
            fontFamily="FontAwesome"
            fill={handleTextColor(p)}
            onClick={() => props.onClick(p)}
            fontSize={TEXT_SIZE}
            text={blockNameByKey[p].icon}
          />
        </Group>
      );
      rectangles.push(rect);
    } else {
      const p = j++;
      const q = j++;
      rectA = (
        <Group key={p}>
          <Rect
            x={(i * genWidth) / 5}
            y={0}
            width={genWidth / 5}
            height={(genHeight * 0.67) / 2}
            fill={handleColor(p)}
            stroke="#333"
            onClick={() => props.onClick(p)}
            shadowForStrokeEnabled
          />
          <Text
            x={(i * genWidth) / 5 + genWidth / 10 - FIX_POS}
            y={(genHeight * 0.67) / 4 - FIX_POS}
            fontFamily="FontAwesome"
            fill={handleTextColor(p)}
            onClick={() => props.onClick(p)}
            fontSize={TEXT_SIZE}
            text={blockNameByKey[p].icon}
          />
        </Group>
      );
      rectB = (
        <Group key={q}>
          <Rect
            x={(i * genWidth) / 5}
            y={(genHeight * 0.67) / 2}
            width={genWidth / 5}
            height={(genHeight * 0.67) / 2}
            fill={handleColor(q)}
            stroke="#333"
            onClick={() => props.onClick(q)}
            shadowForStrokeEnabled
          />
          <Text
            x={(i * genWidth) / 5 + genWidth / 10 - FIX_POS}
            y={(genHeight * 0.67) / 2 + (genHeight * 0.67) / 4 - FIX_POS}
            fontFamily="FontAwesome"
            fontSize={TEXT_SIZE}
            fill={handleTextColor(q)}
            onClick={() => props.onClick(q)}
            text={blockNameByKey[q].icon}
          />
        </Group>
      );
      rectangles.push(rectA);
      rectangles.push(rectB);
    }
  }

  for (var i = 0; i < 2; i++) {
    const p = j++;

    let monetizationRects = (
      <Group key={p}>
        <Rect
          x={(i * genWidth) / 2}
          y={0.67 * genHeight}
          width={genWidth / 2}
          height={0.33 * genHeight}
          fill={handleColor(p)}
          stroke="#333"
          onClick={() => props.onClick(p)}
          shadowForStrokeEnabled
        />
        <Text
          x={(i * genWidth) / 2 + genWidth / 4 - FIX_POS}
          y={0.67 * genHeight + (0.33 * genHeight) / 2 - FIX_POS}
          fontFamily="FontAwesome"
          fontSize={TEXT_SIZE}
          fill={handleTextColor(p)}
          onClick={() => props.onClick(p)}
          text={blockNameByKey[p].icon}
        />
      </Group>
    );
    rectangles.push(monetizationRects);
  }

  console.group();
  console.log('GenWidth: ', genWidth);
  console.log('GenHeight: ', genHeight);

  console.groupEnd();

  return (
    <Group width={genWidth} height={genHeight}>
      {rectangles.map((key, id) => key)}
    </Group>
  );
};
